// extracted by mini-css-extract-plugin
export default {"container":"sqior-marker_container__z-QLu","label":"sqior-marker_label__ArglS"};